import React from 'react';
import './GuidanceNotePanel.scss';

const GuidanceNotePanel = ({ title, description, url, isTemplate = false }) =>
{
    const icon = isTemplate ? 'bi-file-earmark-arrow-down' : 'bi-file-earmark-text';

    return (
        <a className={`note-panel${isTemplate ? ' note-panel-template' : ''}`}
           href={url}
           {...(isTemplate ? {} : { target: '_blank', rel: 'noopener noreferrer' })}>
            <div className='note-panel-icon'><i className={`bi ${icon}`}></i></div>
            <div className='note-panel-body'>
                <h2>{title}</h2>
                {description && <p>{description}</p>}
                <div className='note-panel-foot'>
                    { /* <span className='note-panel-tag'>{isTemplate ? 'Template' : 'Guidance'}</span> */ }
                    <span></span>
                    <span className='note-panel-go'>
                        {isTemplate ? 'Download' : 'Open'}
                        {!isTemplate && <i className='bi bi-box-arrow-up-right'></i>}
                    </span>
                </div>
            </div>
        </a>
    );
}

export default GuidanceNotePanel;
